<template>
    <section class="awaiting-bonus-sec deposit_page_sec withdraw_page_sec">
        <section class="recent-wrapper wallet-recent-wrapper">
            <div class="container">
                <div class="thm-heading wallet-deposit-heading">
                    <div class="go-back-btn">
                        <span class="Withdraw-link">
                            <a class="go_back_btn12" @click="$router.go(-1)">
                                <i class="fa-solid fa-angle-left"></i>
                            </a>
                        </span>
                        <h3>Withdraw</h3>
                    </div>
                    <div class="withdrawal-sec">
                    <div class="add_acc_head">
                        <button type="button" data-bs-toggle="modal" data-bs-target="#acc-open-model">{{ $t('add-account', 'Add account') }}</button>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <div class="deposit_page_div">
            <div class="dw_bg_cl">
                <div class="container-fluid">
                    <div class="withdrawal-main-body">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                                <div class="depo-lft-container">
                                    <div class="description-card-body account_data_parent">
                                        <div class="row">
                                            <div class="col-12" v-for="(item, index) in accountsList" :key="index">
                                                <div class="card-item selected_bank_card">
                                                    
                                                    <div class="account-data" :class="{ 'selected-card': selectedCardIndex === index, 'non-selected-card': selectedCardIndex !== index && selectedCardIndex !== null }"
                                                        @click="selectCard(index, item.client_account_id)">

                                                    <button type="button" class="delete-account-btn" @click="selectedRemoveAcc = item; openDeleteModal()">
                                                        <i class="fa-solid fa-trash"></i>
                                                    </button>
                                                    <div class="about-text">
                                                        <h5 class="card_title_cl">{{ item.method_name ? item.method_name : item.payment_type_name  }}</h5>
                                                    </div>

                                                        <p class="card-text add_bank_acc_list" v-if="item?.payment_method">
                                                            <span>
                                                                {{ $t('payment-type', 'Payment Type') }}
                                                            </span>
                                                            <span>:</span>
                                                            <span> {{ item?.payment_method }}</span>
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData($event,this.$t('payment-type', 'Payment Type'), item?.payment_method)">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                            </button>
                                                        </p>
                                                        
                                                        <p class="card-text add_bank_acc_list" v-if="item?.account_number">
                                                            <span>{{ $t('ac-number', 'A/C Number') }}</span>
                                                            <span>:</span>
                                                            <span>{{ item?.account_number ? item?.account_number : item?.phone_number }}</span>
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData($event,$t('ac-number', 'A/C Number'), item?.account_number)">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                            </button>
                                                        </p>
                                                        
                                                        <p class="card-text add_bank_acc_list" v-if="item?.payment_method == 'bank' && item?.ifsc_code">
                                                            <span>
                                                                {{ $t('ifsc-code', 'IFSC Code') }}
                                                            </span>
                                                            <span>:</span>  
                                                             <span>
                                                               {{ item?.ifsc_code }}
                                                            </span>   
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData($event, $t('ifsc-code', 'IFSC Code'), item?.ifsc_code)">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                            </button>
                                                        </p>
                                                        <p class="card-text add_bank_acc_list" v-if="item?.payment_method == 'upi' && item?.upi_id">
                                                            <span>
                                                                {{ $t('upi-id', 'UPI ID') }}
                                                            </span>
                                                            <span>:</span>  
                                                             <span>
                                                               {{ item?.upi_id }}
                                                            </span>   
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData($event,$t('upi-id', 'UPI ID') ,item?.upi_id )">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                            </button>
                                                        </p>
                                                        <p class="card-text add_bank_acc_list" v-if="item?.payment_method == 'wallet' && item?.crypto_wallet_id">
                                                            <span>
                                                                {{ $t('wallet-id', 'Wallet ID') }}
                                                            </span>
                                                            <span>:</span>  
                                                             <span>
                                                               {{ item?.crypto_wallet_id }}
                                                            </span>   
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData($event,$t('wallet-id', 'Wallet ID'), item?.crypto_wallet_id)">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                            </button>
                                                        </p>
                                                        
                                                        <p class="card-text add_bank_acc_list">
                                                            <span>
                                                                {{ $t('account-holder-name', 'Account Holder’s Name') }} 
                                                            </span>
                                                           <span>:</span>
                                                            <span>
                                                                {{ item?.account_holder_name }}
                                                            </span>
                                                            <button class="btn txt_copy_cl" @click="copyPaymentData($event,this.$t('account-holder-name', 'Account Holder’s Name'), item?.account_holder_name)">
                                                                <i class="fa-solid fa-copy"></i>
                                                                <!-- <div class="text_copy_cl" v-if="copiedText"> <span>{{ $t('copied', ' Copied') }}!</span> </div> -->
                                                            </button>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <form class="withdrawalForm amount_select_filed" v-if="accountsList && accountsList.length >0">
                                                <div class="avail_enter_amout_header">
                                                    <!-- <label for="">Enter amount</label> -->
                                                    <label class="withdraw_title_amount_cl withdraw_bal_section avail_balance_val m-0">
                                                        {{ $t('available-amount','Aval Amount') }} :<span class="val_color_aval">{{ withdrawlBalance }}</span>
                                                    </label>
                                                </div>
                                                <input type="tel" :id="'amount' + index" maxlength="10" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.withdrawal_range?.max || 99999999)" class="form-control withdraw_amount_input" :placeholder="$t('enter-amount','Enter Withdrawal Amount')" v-model="amount">
                                                <div class="d-flex justify-content-end align-items-center">
                                                    <label class="font-right m-0">
                                                        {{ $t('min', 'Min') }}: {{ walletConfig?.withdrawal_range?.min }} |
                                                        {{ $t('max', 'Max') }}: {{ walletConfig?.withdrawal_range?.max }}
                                                    </label>
                                                    
                                                </div>
                                                <button type="button" :class="{'btn-disabled' : amount < walletConfig?.withdrawal_range?.min }" @click="withdrawAmountFuncCall()" class="withdrawBtn">
                                                    {{ $t('withdraw', 'Withdraw') }}
                                                </button>
                                            </form>
                                            <section v-else>
                                                    <p class="error-msg"><small>{{ $t('add-acccount-to-withdraw', 'Add Account to Withdraw...') }}</small></p>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                                <div class="depo-lft-container">
                                    <WalletInstructions instructionType="withdrawal" />
                                </div>
                            </div>
                            <TutorialVideo type = "1"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="delete_account_modal">
        <div class="modal fade" id="deletemodal1" ref="deleteModalRef">
            <div class="modal-dialog modal-dialog-centered">
                <DeleteModal v-if="selectedRemoveAcc" @yes-click="removeAccountHere()" @close="closeModal()" :item="selectedRemoveAcc" />
            </div>
        </div>
    </div>
    <WithdrawalPasswordSetReset ref="withdrawSetReset"/>
    <AddBankAccount ref="addBankRef" @open-withdraw-password-modal="openWithdrawPasswordModal()" :getAccountDetailList="getAccountDetailList" :paymentMethodList="paymentMethodList"/>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { defineAsyncComponent } from 'vue';
import {getUserAccounts, withdrawWalletAmount, withdrawAmountClickValidation} from '../services/walletWithdraw';
import {openWithdrawPasswordModal} from '../services/withdrawAccountDetails';
import WalletInstructions from '../components/WalletInstructions.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import AddBankAccount from '../components/AddAccount.vue';
import WithdrawalPasswordSetReset from '../components/WithdrawalPasswordSetReset.vue';
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
import DeleteModal from '../components/DeleteModal.vue';
export default {
    name: 'Withdrawal',
    components:{
        DeleteModal,
        NoDataFound,
        WithdrawalPasswordSetReset,
         AddBankAccount,
        TutorialVideo,
        WalletInstructions,
    },
    setup() {
		return { v$: useVuelidate() }
	},
    inject: ['walletHeader','walletConfig','onlyBank'],
    data() {
        return {
            amount: '',
            loading: false,
            OTPloading: false,
            walletData: null,
            accountsList: [],
            selectBankId: null,
            onlyBankStatus: false,
            selectedRemoveAcc: null,
            selectedCardIndex: null,
            paymentMethodList:[],
        }
    },
     mounted() {
        this.walletData = this.walletConfig;
        this.getAccountDetailList();
	},
    computed:{
        withdrawlBalance() {
            let { balance = 0, exposure = 0 } = this.$auth?.user || {};
            let earnBonus = this.$auth.user.earnBonus || 0;
            return (parseFloat(balance) + parseFloat(exposure || 0) - parseFloat(earnBonus)).toFixed(2);
        }
    },
   methods: {
		async openWithdrawPasswordModal(){
            try{
                this.OTPloading = true;
                let response = await openWithdrawPasswordModal()
                this.OTPloading = false;
                if(!response?.error){
                    //  this.$helper.closeModal('acc-open-model');
                    this.$helper.openModal('#withdrawalPassword');
                    this.$refs.withdrawSetReset.otpHasBeenCalled()
                    this.$refs.withdrawSetReset.resetTimer();
                }else{
                    this.$errorToast(response?.error);
                }
            }
            catch(error){
                this.OTPloading = false;
                if(error) {
                    this.$errorToast(error);
                }
            }
        },
        addAccountServiceCall(){
            this.$refs?.addBankRef?.addAccountServiceCall(true);
        },
        selectCard(index, bankId) {
            this.selectedCardIndex = index;
            this.selectBankId = bankId;
        },
        openDeleteModal() {
			this.$nextTick(() => {
                this.$helper.openModal('#deletemodal1')
			});
		},
        removeAccountHere() {
			this.closeModal();
            this.getAccountDetailList()
		},
		closeModal() {
            this.selectedRemoveAcc = null;
            this.$helper.closeModal('deletemodal1')
		},
        async withdrawAmountFuncCall() {
            let isValid = await withdrawAmountClickValidation(this.amount, this.walletConfig, this.withdrawlBalance);
            if (isValid) {
                this.$store.dispatch('setGlobalLoader', true);
                let response = await withdrawWalletAmount(this.amount, this.selectBankId);
                this.$store.dispatch('setGlobalLoader', false);
                if (!response?.error) {
                    this.$router.push('/');
                } else {
                    console.error('Withdrawal error:', response.error);
                }
            }
		},
        async getAccountDetailList(reconnectTry = 0){
            try{
                let response = await getUserAccounts(this.walletConfig?.payment_method,reconnectTry)
                this.accountsList = response?.userAccounts,
                this.paymentMethodList = response.paymentMethods
                if (this.accountsList?.length > 0) {
                    this.selectedCardIndex = 0;
                    this.selectBankId = this.accountsList[0].client_account_id;
                }
            }
            catch(error){
                this.loading = false;
                if (error) {
                    this.$errorToast(error?.[0]);
                }

            }
        },
        copyPaymentData(event,catagory, accountData) {
            var input = document.createElement('textarea');
            input.innerHTML = accountData;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);      
            this.copiedText = accountData;
            this.$successToast(catagory + ' Copied');
            document.querySelectorAll('.copt_btn_toolTips .copty_cmn_btn i').forEach(el => {
                el.style.color = ''; 
            });
            this.copiedText = null;
            event.target.style.color = '#0cddff';
            setTimeout(() => {
                event.target.style.color = '';
            }, 1000);
        },
    }
}
</script>
<style scoped>
.btn-disabled{
  pointer-events: none;
  opacity: 0.5;
}
.withdraw_amount_input:focus {
   border: 1px solid #b3a8a8 !important;
}
</style>